import React, {Component} from 'react';
import {browserHistory} from "react-router";
import {PATH_ADOPTAR_ID, PATH_BUSCADOR_ANIMALES_ADMIN_ANIMAL_ID} from "../../../../App/RouterAdopta";
import ClassNames from 'classnames';
import {LazyLoadImage} from "react-lazy-load-image-component";


class CardListingAnimal extends Component {

    constructor(props) {
        super(props);

        // this.props.isLogin();

        this.state = {
            img: undefined
        }
        this.configEstadoContacto = {
            id: "",
            collSize: "divSelectContactoAnimal",
            seleccionado: "",
            placeHolder: "Estados",
            data: ["¿Quieres saber más?"],
            messageWhatsapp: "Hola!%20Quiero%20m%C3%A1s%20informaci%C3%B3n%20de%20",
            idSelect: "contactoAnimal",
            divSelect: ".divSelectContactoAnimal",
            tipo: 'animal'
        };

        //Config información
        this.configInformation = {
            titleHead: "Compartir",

            socials: [
                {
                    url: "",
                    socialIcon: "lab la-facebook-f"
                },
                {
                    url: "",
                    socialIcon: "lab la-twitter"
                },
                {
                    url: "",
                    socialIcon: "lab la-instagram"
                }
            ]
        };


        this.handleModify = this.handleModify.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleImageLoaded = this.handleImageLoaded.bind(this);
        this.handleImageError = this.handleImageError.bind(this);
    }

    handleModify(idAnimal) {
        console.log("CardListingAnimal::handleModify()");
        browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_ANIMAL_ID + idAnimal);
    }


    handleDelete() {
        this.props.removing(true, this.props.animalsControl);
        this.props.changeWaitBlock(true);
    }

    capitalizeString(tkn) {
        if (tkn != undefined) {
            const REG_EXP_SEPARADORES = new RegExp(/[-.–\-,\/():“”"’'’#!?¿¡"@`^&]/, "gi")

            tkn = tkn.toLowerCase()
            let primeraLetra
            if (REG_EXP_SEPARADORES.test(tkn.slice(0, 1))) {
                primeraLetra = tkn.slice(0, 1) + tkn.slice(1, 2).toUpperCase()
                tkn = primeraLetra + tkn.slice(2, tkn.length)
            } else {
                primeraLetra = tkn.slice(0, 1).toUpperCase()
                tkn = primeraLetra + tkn.slice(1, tkn.length)
            }
        }

        return tkn;
    }


    renderImg(isReady, srcImage) {
        //console.log("CardEntityListing::renderImg() -> " + srcImage);
        let {img} = this.state
        if (img !== undefined) {
            //console.log("img en cache");
            return img
        } else {
            //console.log("creando img");

            img = <LazyLoadImage
                id={"img-animal-" + this.props.animal._id}
                key={this.props.animal._id}
                style={isReady ? {} : {display: 'none'}}
                className="img-fluid"
                // alt={`image-${nombre}`}
                src={srcImage}
                width="398"
                height="298"
                threshold={150}

                onLoad={this.handleImageLoaded.bind(this, this.props.index)}
                onError={this.handleImageError}
                onClick={this.props.onClickCard}
                data-indexrow={Math.trunc(this.props.index / this.props.elementsPerRow)}
                data-id={this.props.animal._id}
            />

            this.setState({...this.state, img: img})


            return (img)

        }


    }

    render() {
        let direccion;

        let classReady = "";
        let isReady = this.props.isReady;
        if (isReady) {
            classReady = "listing-houses__item-image";
        } else {
            //Caso en que estén cacheadas...
            if (this.props.imagesLoaded === 0) {
                classReady = "listing-houses__item-image";
                isReady = true;
            } else {
                classReady = "listing-houses__item-image image_holder";
            }
        }

        let srcImage = this.props.animal.img_principal && this.props.animal.img_principal.url
            ? this.props.animal.img_principal.url
            : `${process.env.CDN_URL}/images/adoptaunanimal/default/'${this.props.animal.especie.toLowerCase()}.webp'`
        // : getImageEncode("default." + this.props.animal.especie.toLowerCase())

        let razas = this.props.animal.raza.join(', ').replace(/,(?!.*,)/gmi, ' y')
        let nombre = this.capitalizeString(this.props.animal.nombre)

        if ($(window).width() > 1250) {
            nombre = (nombre.length > 22) ? nombre.slice(0, 22).trim() + "..." : nombre.trim()
            razas = (razas.length > 32) ? razas.slice(0, 32) + "..." : razas
        } else if ($(window).width() > 998) {
            nombre = (nombre.length > 18) ? nombre.slice(0, 18).trim() + "..." : nombre.trim()
            razas = (razas.length > 26) ? razas.slice(0, 26) + "..." : razas
        } else {
            nombre = (nombre.length > 16) ? nombre.slice(0, 16).trim() + "..." : nombre.trim()
            razas = (razas.length > 26) ? razas.slice(0, 26) + "..." : razas
        }
        let estado
        if (this.props.animal.estado === "Urgente") {
            estado = "en adopción Urgente"
        } else {
            estado = this.props.animal.estado
        }
        const nombreProtectora = (this.props.animal.protectora && this.props.animal.protectora.nombre) ? this.props.animal.protectora.nombre : undefined

        return (
            <div id={"card-" + this.props.animal._id}
                 key={"card-" + this.props.animal._id}
                 className={ClassNames("listing-houses__item", {"listing-houses__item--selected": this.props.index === this.props.indexSelected})}
                 onClick={this.props.onClickCard}
                 data-index={this.props.index}
                 data-indexrow={Math.trunc(this.props.index / this.props.elementsPerRow)}
                 data-id={this.props.animal._id}
            >
                <div className={classReady + " img-hover-zoom"}
                     onClick={this.props.onClickCard}
                     data-index={this.props.index}
                     data-indexrow={Math.trunc(this.props.index / this.props.elementsPerRow)}
                     data-id={this.props.animal._id}>
                    <div
                        data-index={this.props.index}
                        className="listing-houses_icon-no-pic"
                        style={!isReady ? {} : {display: 'none'}}>
                        <span className="las la-4x la-image"/>
                    </div>


                    <LazyLoadImage
                        id={"img-animal-" + this.props.animal._id}
                        key={this.props.animal._id}
                        style={isReady ? {} : {display: 'none'}}
                        className="img-fluid"
                        alt={`image-${nombre}`}
                        src={srcImage}
                        width="398"
                        height="298"
                        threshold={150}
                        onLoad={this.handleImageLoaded.bind(this, this.props.index)}
                        onError={this.handleImageError}
                        onClick={this.props.onClickCard}
                        data-indexrow={Math.trunc(this.props.index / this.props.elementsPerRow)}
                        data-id={this.props.animal._id}
                    />


                    {isReady &&
                        <a onClick={this.props.onClickCard} data-index={this.props.index}
                           data-indexrow={Math.trunc(this.props.index / this.props.elementsPerRow)}
                           data-id={this.props.animal._id}
                           href="#" className="listing-houses__item-image-preview">
                            <span className="las la-lg la-search"/>
                        </a>
                    }

                </div>

                {isReady &&
                    <div className="listing-animal__item-info">
                        {this.props.access.isLogin && this.renderTagPublicado(this.props.animal)}

                        <span
                            className={(this.props.animal.sexo === "M") ? "la genero-ficha la-mars" : "la genero-ficha la-venus"}/>

                        <div className="listing-animal__item-title">
                            <span className="listing-animal__item-title"> {nombre}</span>
                        </div>

                        <div className="listing-animal__item-subtitle">
                            <h2 className="listing-animal__item-subtitle-current"><strong>{razas}</strong> <span
                                className="tiny">{estado}</span></h2>
                        </div>
                        <div className="listing-animal__extra-info">

                            <div className="listing-animal__item-extra">
                                <i className="las la-lg la-map-marker-alt"/>
                                <h3 className="listing-animal__item-extra-text">{this.props.animal.direccion.municipio}</h3>
                            </div>
                            {nombreProtectora &&
                                <div className="listing-animal__item-extra">
                                    <i className="las la-lg la-home"/>
                                    <h4 className="listing-animal__item-extra-text">{nombreProtectora}</h4>
                                </div>
                            }
                        </div>
                        <div>
                            {
                                ((this.props.access.isLogin
                                        && this.props.access.id === this.props.animal.protectora
                                        && this.props.animalsControlDetail === "animalDetailProtectora")
                                    && this.props.isAdminAnimals) ? (
                                    <div>
                                        <div className="listing-animals__metrics">
                                            <div className="listing-animal__item-extra">
                                                <div className="tooltip">

                                                    <i className="las la-lg la-search"/>
                                                    <span
                                                        className="listing-animal__item-extra">{(this.props.animal.metricas && this.props.animal.metricas.total && this.props.animal.metricas.total.impresiones && this.props.animal.metricas.total.impresiones.perfil) ? this.props.animal.metricas.total.impresiones.perfil : " - "}
                                                        <span className="tooltiptext-left">Impresiones: Veces que se ha mostrado en alguna búsqueda</span>
                                                        </span>
                                                </div>

                                            </div>
                                            <div className="listing-animal__item-extra">
                                                <div className="tooltip">
                                                    <i className="las la-lg la-eye"/>
                                                    <span
                                                        className="listing-animal__item-extra">{(this.props.animal.metricas && this.props.animal.metricas.total && this.props.animal.metricas.total.clics && this.props.animal.metricas.total.clics.perfil) ? this.props.animal.metricas.total.clics.perfil : " - "}
                                                        <span className="tooltiptext">Clics: Veces que se ha clicado sobre la ficha para ver el animal en detalle</span>
                                                        </span>
                                                </div>
                                            </div>
                                            <div className="listing-animal__item-extra">
                                                <div className="tooltip">

                                                    <i className="las la-1x">CTR</i>
                                                    <span
                                                        className="listing-animal__item-extra-info">{(this.props.animal.metricas && this.props.animal.metricas.total && this.props.animal.metricas.total.clics && this.props.animal.metricas.total.clics.perfil && this.props.animal.metricas.total.impresiones && this.props.animal.metricas.total.impresiones.perfil) ? (Math.floor((this.props.animal.metricas.total.clics.perfil / this.props.animal.metricas.total.impresiones.perfil) * 100)) + "%" : " - "}
                                                        <span className="tooltiptext-right">CTR: Porcentaje de clics respecto al número de impresiones. Buenos valores suelen rondar entre 1% y 5%</span>
                                                        </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <a onClick={this.props.onClickCard} data-index={this.props.index}
                                               data-indexrow={Math.trunc(this.props.index / this.props.elementsPerRow)}
                                               data-id={this.props.animal._id}
                                               target={"_blank"}
                                               href={PATH_ADOPTAR_ID + this.props.animal._id}
                                               className="btn btn-outline-primary btn-card-animal">Ver</a>
                                            {/*<span*/}
                                            {/*    className={(this.props.animal.sexo === "M") ? "la genero-ficha la-mars" : "la genero-ficha la-venus"}/>*/}
                                            <a className="btn btn-outline-primary btn-card-animal"
                                               id="btn_back_search" data-index={this.props.index} href="#"
                                               data-indexrow={Math.trunc(this.props.index / this.props.elementsPerRow)}
                                               data-id={this.props.animal._id}
                                               onClick={this.handleModify.bind(this, this.props.animal._id)}> Modificar </a>

                                        </div>
                                    </div>
                                ) : (
                                    <div>

                                        <a onClick={this.props.onClickCard} data-index={this.props.index}
                                           data-indexrow={Math.trunc(this.props.index / this.props.elementsPerRow)}
                                           data-id={this.props.animal._id}
                                           href={PATH_ADOPTAR_ID + this.props.animal._id}
                                           className="btn btn-outline-primary btn-card-animal">Ver {this.props.animal.especie.toLowerCase()}</a>
                                    </div>
                                )
                            }

                        </div>
                    </div>
                }
            </div>
        );
    }

    handleImageLoaded(index, idImage) {
        if (this.props.imageLoaded) this.props.imageLoaded(this.props.animalsControl);
    }

    handleImageError() {
        // this.props.imageError(this.props.animalsControl);
    }

    renderTagPublicado(animal) {
        let className;
        let classIcon;
        let titleTooltip;
        let textTooltip;

        if ((this.props.access.isLogin
                && this.props.access.id === animal.protectora
                && this.props.animalsControlDetail === "animalDetailProtectora")
            && this.props.isAdminAnimals) {

            if ((animal.estado !== "Adoptado" && animal.estado !== "Sacrificado") && (animal.img_principal && animal.img_principal.url && !(new RegExp('/default/[a-zA-Z]*.png$').test(animal.img_principal.url)))) {
                className = "listing-houses__item-success";
                classIcon = "las la-lg la-check"
                titleTooltip = "Publicado"
                textTooltip = "Este animal está publicado en el buscador"
            } else {
                classIcon = "las la-lg la-times"
                titleTooltip = "No publicado"

                if ((animal.img_principal && animal.img_principal.url && !(new RegExp('/default/[a-zA-Z]*.png$').test(animal.img_principal.url)))) {
                    className = "listing-houses__item-warning";
                    textTooltip = "No está publicado en el buscador, por que su estado no es adoptable."
                } else {
                    className = "listing-houses__item-alert";
                    textTooltip = "No está publicado en el buscador por que no cumple las normas. Pj: No tener una foto principal"
                }
            }

            return (
                <div className="tagPublicado">
                    <div className={className}>
                        <div className="tooltip">
                            <span className={classIcon}/> {titleTooltip}
                            <span className="tooltiptext-right">{textTooltip}</span>
                        </div>
                    </div>
                </div>
            )


        } else {
            return (<div/>)
        }
    }


    componentWillMount() {


    }

    componentDidMount() {
        // //console.log("CardEntityListing::componentDidMount()");
        // const that = this;
        // $('#card-' + this.props.animal._id).on("click", (e) => {
        //
        //     //console.log("onClic::CardEntityListing");
        //     let element = $("#card-" + that.props.animal._id)
        //
        //     if (element.length !== 0) {
        //         let scroll = element.offset().top
        //         //console.log("onClic::CardEntityListing -> Haciendo scrollTop");
        //         $('body,html').stop(true, true).animate({
        //             scrollTop: scroll - 40 //element.offsetTop
        //         }, 250);
        //     }
        // });
    }

}

export default CardListingAnimal